import React, { Component } from "react";
import { Grid, Header, Image, Placeholder } from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";

import recruitmentImage from "../assets/images/Recruitment2019.jpeg";

class Recruitment extends Component {
  state = { loading: true };

  constructor(props) {
    super(props);
    this.handleImageLoad = this.handleImageLoad.bind(this);
    this.recruitmentDone = true;
  }
  toggleDisplayRecruitment = () => {
    if (this.props.displayRecruitment) {
      this.recruitmentDone = false;
    }
  };

  handleImageLoad() {
    this.setState({ loading: false });
    // console.log("loaded");
  }

  render() {
    let recruitmentDoneImage;
    if (this.props.recruitmentDone) {
      recruitmentDoneImage = (
        <div>
          <Image
            centered
            hidden={true}
            src={CONSTANTS.RECRUITMENT_DONE_IMG}
            onLoad={this.handleImageLoad}
          />
          {this.state.loading ? (
            <Placeholder>
              <Placeholder.Image square />
            </Placeholder>
          ) : (
            <Image
              centered
              rounded
              fluid
              src={CONSTANTS.RECRUITMENT_DONE_IMG}
              onLoad={this.handleImageLoad}
            />
          )}
        </div>
      );
    } else {
      recruitmentDoneImage = (
        <Image centered rounded fluid src={recruitmentImage} />
      );
    }
    return (
      <Grid
        container
        columns="equal"
        stackable
        // verticalAlign="middle"
        style={{ padding: "1em 0em" }}
      >
        <Grid.Row>
          <Grid.Column>
            <div id="recruitment">
              <Header as="h2" style={{ fontSize: "2em" }}>
                Recruitment
              </Header>
            </div>
            <p style={{ fontSize: "1.3em" }}>{CONSTANTS.RECRUITMENT_PARA}</p>
            {/* <p style={{ fontSize: "1.3em" }}>{CONSTANTS.ABOUT_US_PARA_2}</p> */}
          </Grid.Column>
          <Grid.Column floated="right" textAlign="center">
            {recruitmentDoneImage}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      // <Container>

      // </Container>
    );
  }
}

export default Recruitment;
